const agendaEditType = {
  LIST_OF_PROPERTIES: 'ListOfProperty',
  LIST_OF_PEOPLE: 'ListOfPerson',
  REMOVE_FROM_LIST: 'removeFromList',
  UPDATE_APPOINTMENT_BY_RESOURCEID: 'updateAppointmentByResourceId',
  INSERT_APPOINTMENT: 'insertAppointment',
  DELETE_APPOINTMENT: ' deleteAppointment',
  UPDATE_APPOINTMENT: 'updateAppointment',
  UPDATE_APPOINTMENT_BY_DROP: 'updateAppointmentByDrop',
  INSERT_APPOINTMENT_EXCEPTION: 'insertExceptionAppointment',
  INSERT_APPOINTMENT_EXCEPTION_FULL: 'insertFullExceptionAppointment',
  UPDATE_APPOINTMENT_EXCEPTION: 'updateExceptionAppointment',
  Get: {
    CONFIG: 'getConfigs',
    CURRERNT_COMMENT: 'getCurrentComment',
    LIST_OF_APPOINTMENTS: 'getListOfAppointments',
    LIST_OF_APPOINTMENTTYPES: 'getListOfAppointmentTypes',
    LIST_OF_APPOINTMENTTYPES_MASTER: 'getListOfAppointmentTypesMaster',
    LIST_OF_APPOINTMENTSTATUS_MASTER: 'getListOfAppointmentStatusMaster',
    LIST_OF_APPOINTMENTSTATUS: 'getListOfAppointmentStatus',
    LIST_OF_APPOINTMENTTYPEIDS: 'getListOfAppointmentTypeIds',
    LIST_OF_EVENTS: 'getListOfEvents',
    LIST_OF_DISPLAYEVENTS: 'getListOfDisplayEvents',
    LIST_OF_APPOINTMENTCURRENTTYPES: 'getListOfCurrentAppointmentTypes',
    CALENDAR_INFO: 'getCalendarInfo',
    DEFAULT_SUGGESTION_PLACE: 'getDefaultSuggestionPlace',
    GET_AGENDA_PRICE_ESTIMATE: "getAgendaPriceEstimate"
  },
  Set: {
    CONFIG: 'setConfig',
    CONFIG_RESOURCES: 'setConfigResources',
    SEARCH_PARAM: 'setSearchParam',
    APPOINTMENT: 'setAppointment',
    APPOINTMENTORIGIN: 'setAppointmentOrigin',
    ASSIGNVALUE_RECURRENCE: 'setRecurrenceValue',
    ASSIGNVALUE_COMMENT: 'setCommentValue',
    LIST_OF_PROPERTIES: 'setAppointmentProperties',
    LIST_OF_PEOPLE: 'setAppointmentPeople',
    UPDATE_PROPERTY: 'updateAppointmentProperty',
    UPDATE_PERSON: 'updateAppointmentPerson',
    MODAL_VISIBLE: 'setModalVisible',
    MODAL_RECURRENCE_SETING_VISIBLE: 'setModalRecurrenceSettingVisible',
    LIST_OF_APPOINTMENTS: 'setListOfAppointments',
    LIST_OF_APPOINTMENTTYPES: 'setListOfAppointmentTypes',
    LIST_OF_APPOINTMENTTYPES_MASTER: 'setListOfAppointmentTypesMaster',
    LIST_OF_APPOINTMENTSTATUS: 'setListOfAppointmentStatus',
    LIST_OF_APPOINTMENTSTATUS_MASTER: 'setListOfAppointmentStatusMaster',
    LIST_OF_APPOINTMENTTYPEIDS: 'setListOfAppointmentTypeIds',
    LIST_OF_EVENTS: 'setListOfEvents',
    LIST_OF_EVENTSCHECKALL: 'setListOfEventsCheckAll',
    LIST_OF_APPOINTMENTCURRENTTYPES: 'setListOfCurrentAppointmentTypes',
    LIST_OF_COMMENTS: 'setListOfComments',
    LIST_OF_RESOURCEIDS: 'setListOfResourceIds',
    CURRENT_COMMENT: 'setCurrentComment',
    NEW_COMMENTS: 'setNewComment',
    ADD_COMMENT: 'addNewComment',
    UPDATE_EVENT: 'updateEventInfo',
    UPDATE_APPOINTMENT: 'updateAppointmentInfo',
    CALENDAR_INFO: 'setCalendarInfo',
    DEFAULT_SUGGESTION_PLACE: 'setDefaultSuggestionPlace',
    SET_VALUE_POSITIVE: 'setPositiveValue',
    SET_VALUE_NEGATIVE: 'setNegativeValue',
    SET_VALUE_PRICE_ESTIMATE: "setPriceEstimateValue",
    SET_VALUE_FOR_CURRENT_COMMENT: "setValueForCurrentComment",
      LOAD_FROM_TASK: "loadFromTask",
    REFRESH_APPOINTMENT_DATA: "refreshAppointmentData",
    SET_IS_SAVING: 'setIsSaving'
  }
}

export default agendaEditType;